//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SimpleButton",
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingSucceeded: {
      type: Boolean,
      default: true
    },
    type: {
      type: null,
      default: "primary"
    },
    className: {
      type: String,
      default: ""
    },
    buttonType: {
      type: String,
      default: "button"
    },
    clientLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass() {
      if (!Array.isArray(this.type)) return `btn-${this.type}`;
      return this.type.join(" ");
    }
  },
  methods: {
    handleClick() {
      if (this.disabled) return;
      this.$emit("click");
    },
    handleFinish() {
      this.$emit("finish");
    },
    handleDoubleClick() {
      this.$emit("dblclick");
    }
  }
});